// jQuery wrapper
(function($) {

	/**
	 ** Document ready
	 **/
	$(document).ready(function(){

		$('body').addClass('active');


		// WOW.js for animations
		new WOW().init();


		// Smooth Scroll
		$('a.smooth-scroll, button.smooth-scroll').on('click', function(event) {
			event.preventDefault();
			var target = $(this).data('target');
			// var headerHeight = $('#site-header').outerHeight();
			// var scrollPosition = $(target).offset().top - headerHeight;
			var scrollPosition = $(target).offset().top;

			// console.log(headerHeight);

			$('html').animate({
	            scrollTop: scrollPosition
	        }, 1000);
		});


		// Header bar scrolled
		scrollbarState();


		// Accordion list (FAQs / Features)
		if ($('.accordion').length > 0) {
			$('.accordion .answer:not(.active)').hide();

	        var allPanels = $('.accordion .answer');

	        $('.accordion .question').click( function() {
	            var target = $(this).next();

	            // console.log(targetParent);

	            if ( $(target).hasClass('active') ) {
	                $(this).removeClass('current');
	                $(target).removeClass('active').slideUp(250);
	            } else {
	                $('.accordion .question').removeClass('current');
	                $(allPanels).removeClass('active').slideUp(250);
	                $(this).addClass('current');
	                $(target).addClass('active').slideDown(250);
	            }
	            
	            // Prevent default 'link' behaviour
	            return false;
	        });
	    }


		// Pricing Calculator
		if ( $('#price-blocks').length > 0) {
			//$('#price-blocks .session:not(.active)').hide();

			$('.session-select button').click( function() {
				var target = $(this).data('target');
				var group = $(this).data('group');
				
				if ( $(target).hasClass('active') ) {

				} else {
					// Buttons
					$(group + ' .session-select button').removeClass('current');
					$(this).addClass('current');

					// Content
					$(group + ' .session').removeClass('active');
					$(target).addClass('active');
				}
			});
		}


	    /*
		// Team List - Toggle
		if ( $('#team-list').length > 0 ) {
			$('#team-filter').on( 'click', 'button', function() {
				// If not currently active
				if ( !$(this).hasClass('current') ) {

					$('#team-filter button').removeClass('current');
					$(this).addClass('current');

					var target = $(this).attr('data-target');
					$('.team-section').hide();
					$(target).show(); 

					// Rebuild carousels
					var carousel = $(this).data('carousel');
					$('.team-carousel').slick('unslick');
					$(carousel).slick();
				}

			});
		}
		*/


	    // News - Toggle filter on mobile
	    if ( $('#filter-wrap').length > 0 ) {
	    	$('.filter-toggle').on('click', function() {
	    		$(this).toggleClass('active');
	    		$('#filter').toggleClass('open');
	    	})
	    };


	    // Dropkick - custom dropdown/select in Forms
		if ( $('.form-wrap select').length > 0 ) {
		    $('.form-wrap select').dropkick({
		        mobile: true
		    });
		}

		// Dropkick - custom dropdown/select on News Filter
		if ( $('#filter select').length > 0 ) {
		    $('#filter select').dropkick({
		        mobile: true
		    });
		}


		/***
		 * Menus
		 ***/

		// Desktop Menu
		$('#desktop-menu .hasSub > a').click(function(event) {
			event.preventDefault();
			
			var target = '#desktop-submenu ' + $(this).attr('href');

			$('.card .hasSub a').not(this).removeClass('show');

			$('.sub .card').removeClass('show animated fadeIn');

			if ($(this).hasClass('show')) {
				$('#desktop-submenu').removeClass('open');
				$('body').removeClass('dt-menu-open');
				$(target).removeClass('show animated fadeIn');
				$(this).removeClass('show');
			} else {
				$('#desktop-submenu').addClass('open');
				$('body').addClass('dt-menu-open');
				$(target).addClass('show animated fadeIn');
				$('#desktop-menu .hasSub a').removeClass('show');
				$(this).addClass('show');
			}
		});
		$('#desktop-submenu .close-sub').click(function() {
			event.preventDefault();

			var target = '#desktop-submenu ' + $(this).attr('href');
			$('.nav-link.active').removeClass('active');
			$('#desktop-menu .hasSub a').removeClass('show');
			$('#desktop-submenu').removeClass('open');
			$(target).addClass('fadeOut');
			// setTimeout(function(){
			  	$(target).removeClass('fadeOut fadeIn show animated');
			// }, 0);
			$('body').removeClass('dt-menu-open');
		});


		// Mobile Menu - Hamburger
		$('.menu-trigger').click(function() {
			$('.card .hasSub a').removeClass('active');
			$('.card .hasChild a').removeClass('active');
			$('.sub .card').removeClass('show animated fadeIn');
			$('.children .card').removeClass('show animated fadeIn');

			$('body').toggleClass('mob-menu-open');
			$(this).toggleClass('is-active');
			var target = $(this).data('target');
			// console.log(target);
			// $('body').toggleClass('modal-open');
			$(target).toggleClass('open');
			// $('#primary-nav').scrollTop(0);
		});

		// Mobile Menu - First Level
		$('#mobile-menu .hasChild > a').click(function(event) {
			event.preventDefault();
			
			$(this).siblings().toggleClass('open');
			$(this).toggleClass('show');
		});

		// Mobile Menu - Don't close dropdown on link click
		$('#mobile-menu .dropdown-menu .dropdown-item').click( function(e) {
			// console.log('dropdown link clicked');
			e.stopPropagation();
		});


		/*
		 * Carousels
		 */


		// Treatments Carousel (overhang)
		if ( $('.treatment-carousel').length > 0 ) {
			// Carousel progress
			var $slider = $('.treatment-carousel');
			var $progressBar = $('.treatment-progress .progress');
			var $progressBarLabel = $( '.slider__label' );

			$slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
			    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
			    
			    $progressBar
			      	.css('background-size', calc + '% 100%')
			      	.attr('aria-valuenow', calc );
			    
			    $progressBarLabel.text( calc + '% completed' );
		  	});

		  	$('.treatment-carousel .slide').on('mouseenter', function (e) {
		  		$(this).addClass('hover');
		  		$('.treatment-carousel .slide').not(this).addClass('no_hover');
		  	}).on('mouseleave', function(e) {
		  		$(this).removeClass('hover');
		  		$('.treatment-carousel .slide').removeClass('no_hover');
		  	});

		  	// Carousel
			$('.treatment-carousel').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: false,
				arrows: false,
				infinite: true,
				centerMode: false,
				// asNavFor: '.treatment-counter',
			});
		}

		// Conditions Carousel (overhang)
		if ( $('.condition-carousel').length > 0 ) {
			// Carousel progress
			var $slider = $('.condition-carousel');
			var $progressBar = $('.condition-progress .progress');
			var $progressBarLabel = $( '.slider__label' );

			$slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
			    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
			    
			    $progressBar
			      	.css('background-size', calc + '% 100%')
			      	.attr('aria-valuenow', calc );
			    
			    $progressBarLabel.text( calc + '% completed' );
		  	});

		  	$('.condition-carousel .slide').on('mouseenter', function (e) {
		  		$(this).addClass('hover');
		  		$('.condition-carousel .slide').not(this).addClass('no_hover');
		  	}).on('mouseleave', function(e) {
		  		$(this).removeClass('hover');
		  		$('.condition-carousel .slide').removeClass('no_hover');
		  	});

		  	// Carousel
			$('.condition-carousel').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: false,
				arrows: false,
				infinite: true,
				centerMode: false,
				// asNavFor: '.condition-counter',
			});
		}

		// Testimonial Carousel
	    if ( $('.testimonial-carousel').length > 0 ) {	 
	    	$('.testimonial-carousel').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: false,
				// autoplaySpeed: 4500,
				arrows: false,
				dots: true,
				infinite: true,
				fade: true,
				centerMode: false,
			});
	    }

	    // Before & After Carousel
	    if ( $('.ba-carousel').length > 0 ) {
	    	$('.ba-carousel').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: false,
				// autoplaySpeed: 4500,
				arrows: true,
				dots: false,
				infinite: true,
				fade: true,
				centerMode: false,
				prevArrow: $('.ba-carousel-controls .btn-prev'),
				nextArrow: $('.ba-carousel-controls .btn-next'),
			});
	    }

		// Video Carousel
		if ( $('.video-carousel').length > 0 ) {
	    	$('.video-carousel').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: false,
				// autoplaySpeed: 4500,
				arrows: true,
				dots: false,
				infinite: true,
				fade: true,
				centerMode: false,
			});

			// Video modal - Empty player on close	    
			$('.close-video').click( function() {
				$('.video-container').empty();
			});
		}


	    // Team carousels
	    if ( $('.team-carousel').length > 0 ) {
	    	teamCarousels();
	    }


		// Cookies 
	    // Set Cookie function
        function createCookie(name, value, days) {
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                var expires = "; expires=" + date.toGMTString();
            } else var expires = "";
            document.cookie = escape(name) + "=" + escape(value) + expires + "; path=/";
        }
        // Privacy Policy Cookies   
        function cookiesPolicyBar(){
            // Check cookie 
            if ($.cookie('beauPrivacy') != "accepted") $('#cookie-notification').fadeIn(); 

            //Assign cookie on click
            $('#cookie-notification a, #cookie-notification button').on('click',function(){
                createCookie("beauPrivacy", "accepted", 90); // Cookie expires in 90 days
                $('#cookie-notification').fadeOut();
            });
        }           
        // Run cookie policy function
        cookiesPolicyBar();


	}); // End Document Ready


    // On load
	$(window).on('load', function() {

		// Carousel Equal Heights
	    carouselEqualHeights()

	});


	// On Scroll
	$(window).on('scroll', function () {

		// Header bar scrolled
		scrollbarState();

	});


	// On Resize
	$(window).on('resize', function () {

		// Carousel Equal Heights
	    carouselEqualHeights()

	});


	// Header bar scrolled
	function scrollbarState() {
    	var navHeight = $('#site-header').outerHeight();

		if ( $(document).scrollTop() > navHeight ) {
			$('body').addClass('scrolled');
			$('#site-header').addClass('fixed');
		} else {
    		$('body').removeClass('scrolled fixed');
    		$('#site-header').removeClass('fixed');
		}
	}


	// Carousel - Equal heights
	function carouselEqualHeights() {
		$('.carousel.equal').on('setPosition', function () {
			$(this).find('.slick-slide').height('auto');
			var slickTrack = $(this).find('.slick-track');
			var slickTrackHeight = $(slickTrack).height();
			$(this).find('.slick-slide').css('height', slickTrackHeight + 'px');
		});
	}


	function teamCarousels() {
        var teamCarousels = $(".team-carousel:not(.slick-initialized)");
	    teamCarousels.each(function() {
	        $(this).slick({
				adaptiveHeight: false,
		    	arrows: true,
		    	dots: false,
	            fade: false,
		    	infinite: true,
	            slidesToShow: 1,
	            // appendArrows: $('.team-controls .slick-nav'),

	            responsive: [
		    		{
		    			breakpoint: 992,
		    			settings: {
		    				slidesToShow: 1,
		    			}
		    		}
		    	]
		  	});
	    });
	}


// end jQuery wrapper
})(jQuery);
